export default __webpack_public_path__ + "static/media/ls_logo.f7f19420.svg";